module.exports = __webpack_public_path__ + "img/logo_5A_zh_CN.1e6e08af.png";